import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import * as dayjs from 'dayjs';

export class DateValidators {
  public static minDate = (date: dayjs.Dayjs = dayjs('1900-01-01')): ValidatorFn => {
    return (ctrl: AbstractControl): { [key: string]: boolean } | null => {
      if (ctrl.value) {
        const currentValue = dayjs(ctrl.value);
        const minDate = date;
        if (!(currentValue.isSame(minDate, 'day') || currentValue.isAfter(minDate, 'day'))) {
          return { minDate: false };
        }
      }
      return null;
    };
  };

  public static maxDate = (date: dayjs.Dayjs = dayjs(new Date())): ValidatorFn => {
    return (ctrl: AbstractControl): { [key: string]: boolean } | null => {
      if (ctrl.value) {
        const currentValue = dayjs(ctrl.value);
        const maxDate = date;
        if (!(currentValue.isSame(maxDate, 'day') || currentValue.isBefore(maxDate, 'day'))) {
          return { maxDate: false };
        }
      }
      return null;
    };
  };

  public static isDateSameOrAfter(compareDateControl: FormControl<Date>): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const date = control.value;
      const compareDate = compareDateControl.value;
      if (date && compareDate) {
        const isDateSameOrAfter = dayjs(date).isSame(dayjs(compareDate)) || dayjs(date).isAfter(dayjs(compareDate));
        return isDateSameOrAfter
          ? null
          : {
              dateIsNotSameOrAfter: true,
            };
      }
      return null;
    };
  }
}
